import { action, makeAutoObservable, observable } from "mobx"
import { useState } from "react"

class Form {

  data = observable.map<string, string>([])
  constructor(initialData: { [ key: string ]: string }) {
    this.data.replace(Object.entries(initialData))
    makeAutoObservable(this, {
      set: action
    })
  }

  set(key: string, value: string) {
    this.data.set(key, value)
  }

  get(key: string) {
    return this.data.get(key)
  }

  getProps(key: string, defaultValue = "") {
    return {
      value: this.get(key) || defaultValue,
      onChange: (e: any) => this.set(key, e.target.value)
    }
  }

}

export const useForm = (initialData: { [ key: string ]: string } = {}) => {
  const [ form ] = useState(() => new Form(initialData))
  return form
}